<script setup>
const props = defineProps({
  modelValue: [String, Number],
  label: String,
  placeholder: String,
  disabled: Boolean,
  maxLength: Number,
  row: Number,
  cols: Number,
});

const emit = defineEmits(["update:modelValue"]);

const updateValue = (event) => {
  emit("update:modelValue", event.target.value);
};
</script>
<template>
  <div class="mb-2">
    <label
      class="text-[14px] text-gray-900 block mb-2 font-palanquin text-md font-medium"
    >
      {{ label }}
    </label>
    <div
      class="relative bg-gray-50 border text-gray-900 text-sm rounded-md block w-full"
    >
      <TextArea
        :type="inputType"
        :placeholder="placeholder"
        class="w-full bg-transparent resize-none outline-none focus:ring-green-300 focus:border-green-300 p-2.5 pr-10"
        :value="modelValue"
        @input="updateValue"
        :disabled="disabled"
        :rows="row"
        :cols="cols"
      />
    </div>
    <span v-if="error" class="text-red-500 text-xs mt-1">{{ error }}</span>
  </div>
</template>